import { isExperimentalFeatureEnabled } from '../domain/configuration';
import { computeBytesCount, deepClone, jsonStringify } from './utils';
import { sanitize } from './sanitize';
export function createContextManager(computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = computeBytesCount; }
    var context = {};
    var bytesCountCache;
    return {
        getBytesCount: function () {
            if (bytesCountCache === undefined) {
                bytesCountCache = computeBytesCountImpl(jsonStringify(context));
            }
            return bytesCountCache;
        },
        /** @deprecated use getContext instead */
        get: function () { return context; },
        /** @deprecated use setContextProperty instead */
        add: function (key, value) {
            context[key] = value;
            bytesCountCache = undefined;
        },
        /** @deprecated renamed to removeContextProperty */
        remove: function (key) {
            delete context[key];
            bytesCountCache = undefined;
        },
        /** @deprecated use setContext instead */
        set: function (newContext) {
            context = newContext;
            bytesCountCache = undefined;
        },
        getContext: function () { return deepClone(context); },
        setContext: function (newContext) {
            context = isExperimentalFeatureEnabled('sanitize_inputs') ? sanitize(newContext) : deepClone(newContext);
            bytesCountCache = undefined;
        },
        setContextProperty: function (key, property) {
            context[key] = isExperimentalFeatureEnabled('sanitize_inputs') ? sanitize(property) : deepClone(property);
            bytesCountCache = undefined;
        },
        removeContextProperty: function (key) {
            delete context[key];
            bytesCountCache = undefined;
        },
        clearContext: function () {
            context = {};
            bytesCountCache = undefined;
        },
    };
}
//# sourceMappingURL=contextManager.js.map